// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';

type PropTypes = {|
  title?: string,
  intro?: string,
  surveyMonkeyId: string,
|};

export default (props: PropTypes) => {
  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://widget.surveymonkey.com/collect/website/js/${props.surveyMonkeyId}.js`;

    if (document.head) {
      document.head.appendChild(script);
    }

    return () => {
      script.remove();
    };
  }, [props.surveyMonkeyId]);

  return (
    <PageContentBlock title={props.title} intro={props.intro} layout="Thin">
      <div className={styles.surveyMonkey}>
        <div id="smcx-sdk" />
      </div>
    </PageContentBlock>
  );
};
